import { Modal } from "react-bootstrap"
import { useMutation } from "react-query"
import { toast } from "react-toastify"

import { saveCourseSession } from "../../../../../../models/courses/courses"
import CourseSessionForm from "./CourseSessionForm"


const CreateSessionModal = ({ queryClient, scheduleQueryKey, schedule, courseId, show, onHide }) => {
    const { mutate, isLoading } = useMutation(data => saveCourseSession(courseId, schedule.id, data), {
        onSuccess: () => {
            toast.success('Success')
            queryClient.invalidateQueries([scheduleQueryKey])
            onHide()
        },
        onError: error => {
            toast.error(error.message)
        }
    })

    return (
        <Modal show={show} onHide={onHide} backdrop="static" keyboard={false} centered>
            <Modal.Header closeButton>
                <Modal.Title>Create Session</Modal.Title>
            </Modal.Header>
            <Modal.Body>
                <div className="rounded border p-3 bg-light-primary">
                    <p className="mb-0 fw-semibold">Schedule: {schedule.name}</p>
                </div>
                <div className="separator my-6"></div>
                <CourseSessionForm
                    schedule={schedule}
                    courseId={courseId}
                    onSubmit={data => mutate(data)}
                    submitLoading={isLoading}
                />
            </Modal.Body>
        </Modal>
    )
}

export default CreateSessionModal